/* Recently Viewed
 * - Captures the current product (on product pages) into the visitor's
 *   localStorage history.
 * - Renders that history into any [data-recently-viewed] section, reusing the
 *   theme's product-card design via the Section Rendering API.
 * The storage key is versioned (rs_recently_viewed_v<N>) so that bumping the
 * "Geçmiş sürümü" theme setting resets every visitor's history.
 */
(function () {
  if (window.__rsRecentlyViewedInit) return;
  window.__rsRecentlyViewedInit = true;

  var CFG = window.__rsRecentlyViewed || {};
  var BASE_KEY = 'rs_recently_viewed';

  function getVersion() {
    var el = document.querySelector('[data-recently-viewed]');
    if (el && el.dataset.version) return el.dataset.version;
    if (CFG.version != null) return String(CFG.version);
    return '1';
  }

  function storageKey() {
    return BASE_KEY + '_v' + getVersion();
  }

  function read(key) {
    try {
      var arr = JSON.parse(localStorage.getItem(key));
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(key, arr) {
    try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {}
  }

  // Drop history stored under any other version (supports the global reset).
  function cleanupOldVersions(currentKey) {
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && k.indexOf(BASE_KEY + '_v') === 0 && k !== currentKey) {
          localStorage.removeItem(k);
        }
      }
    } catch (e) {}
  }

  function capture(key) {
    if (!CFG.handle) return;
    var cap = parseInt(CFG.cap, 10);
    if (!cap || cap < 1) cap = 20;
    var list = read(key).filter(function (h) { return h && h !== CFG.handle; });
    list.unshift(CFG.handle);
    if (list.length > cap) list = list.slice(0, cap);
    write(key, list);
  }

  function render(key) {
    var container = document.querySelector('[data-recently-viewed]');
    if (!container) return;
    var grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var count = parseInt(container.dataset.count, 10) || 8;
    var exclude = container.dataset.currentHandle || CFG.handle || '';
    var cardSection = container.dataset.cardSection || 'recently-viewed-card';
    var sectionId = container.dataset.sectionId || 'rv';

    var handles = read(key)
      .filter(function (h) { return h && h !== exclude; })
      .slice(0, count);

    if (!handles.length) return;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + cardSection, {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var index = 0;
      htmls.forEach(function (html) {
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html.trim();
        var card = temp.querySelector('.product-card');
        if (!card) return; // empty response or gift product -> skip
        index++;
        var slide = document.createElement('div');
        slide.className = 'fp__slider-item slider__slide';
        slide.id = 'Slide-' + sectionId + '-' + index;
        slide.appendChild(card);
        grid.appendChild(slide);
      });

      if (!grid.children.length) return;

      container.removeAttribute('hidden');

      // Re-initialise the slider now that slides exist (prev/next pagination).
      var slider = container.querySelector('slider-component');
      if (slider && typeof slider.resetPages === 'function') {
        slider.resetPages();
      }
    });
  }

  function init() {
    var key = storageKey();
    cleanupOldVersions(key);
    capture(key);

    var container = document.querySelector('[data-recently-viewed]');
    if (!container) return;

    // The section starts hidden (display:none). A display:none element is never
    // reported as "intersecting", so lazy-loading via IntersectionObserver here
    // would leave it hidden forever. Render when the browser is idle instead;
    // the product-card images are themselves lazy-loaded (loading="lazy").
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { render(key); });
    } else {
      setTimeout(function () { render(key); }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
